import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { startLogin, startChecking } from '../../action/auth';
import { useForm } from '../../hooks/useForm';
import { Loading } from '../Loading';
import { navigate } from "gatsby"

// Importación del logo del colegio
import logoColegio from '../../images/logo.png';

export const FormLogin = () => {
    const dispatch = useDispatch()
    const { checking, uid } = useSelector(state => state.auth);

    const [ login, handleInputChange ] = useForm({
        rut: '',
        password: ''
    })
    const { rut, password } = login;
    
    const handleLogin = (e) => {
        e.preventDefault();
        dispatch(startLogin(rut, password));
    };

    useEffect(() => {
        dispatch(startChecking());
    }, [dispatch]);

    useEffect(() => {
        if(uid){
            setTimeout(() => {
                navigate("/credencialUsuario/")
            }, 1500);
        }
    }, [uid]);
    
    if ( checking ) {
        return (
            <Loading />
        )
    };

    return (
        <div className="container d-flex justify-content-center align-items-center min-vh-100 px-3">
            <div 
                className="card border-secondary border-opacity-25 shadow-lg rounded-4 overflow-hidden w-100" 
                style={{ 
                    maxWidth: '400px', 
                    backgroundColor: 'rgba(15, 23, 42, 0.75)', 
                    backdropFilter: 'blur(10px)',
                    WebkitBackdropFilter: 'blur(10px)'
                }}
            >
                {/* Header con Logo Institucional sobre fondo oscuro semitransparente */}
                <div 
                    className="card-header text-white text-center py-4 px-4 border-bottom border-secondary border-opacity-25"
                    style={{ backgroundColor: 'rgba(30, 41, 59, 0.5)' }}
                >
                    <div className="mb-3">
                        <img 
                            src={ logoColegio } 
                            alt="Logo Colegio" 
                            style={{ 
                                maxHeight: '75px', 
                                maxWidth: '100%', 
                                objectFit: 'contain',
                                filter: 'drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.4))' 
                            }} 
                        />
                    </div>
                    <h4 className="fw-bold mb-1" style={{ letterSpacing: '0.5px' }}>Acceso al Sistema</h4>
                    <p className="small mb-0 text-white-50">Libro Digital Escolar</p>
                </div>

                {/* Cuerpo del Formulario */}
                <div className="card-body p-4 p-sm-5">
                    <form onSubmit={ handleLogin }>
                        
                        {/* Campo RUT */}
                        <div className="mb-4">
                            <label htmlFor="rut" className="form-label text-white-50 small fw-medium mb-2">
                                RUT
                            </label>
                            <div className="input-group">
                                <span className="input-group-text bg-dark bg-opacity-50 border-secondary border-opacity-25 text-white-50 px-3">
                                    <i className="fas fa-id-card"></i>
                                </span>
                                <input 
                                    type="text" 
                                    className="form-control bg-dark bg-opacity-50 border-secondary border-opacity-25 text-white placeholder-white-50 shadow-none py-2" 
                                    id="rut"
                                    name="rut"
                                    placeholder="12345678-9"
                                    autoComplete="username"
                                    value={ rut }
                                    onChange={ handleInputChange }
                                    required
                                />
                            </div>
                        </div>

                        {/* Campo Contraseña */}
                        <div className="mb-4">
                            <label htmlFor="password" className="form-label text-white-50 small fw-medium mb-2">
                                Contraseña
                            </label>
                            <div className="input-group">
                                <span className="input-group-text bg-dark bg-opacity-50 border-secondary border-opacity-25 text-white-50 px-3">
                                    <i className="fas fa-key"></i>
                                </span>
                                <input 
                                    type="password" 
                                    className="form-control bg-dark bg-opacity-50 border-secondary border-opacity-25 text-white placeholder-white-50 shadow-none py-2" 
                                    id="password"
                                    name="password"
                                    placeholder="••••••••"
                                    autoComplete="current-password"
                                    value={ password }
                                    onChange={ handleInputChange }
                                    required
                                />
                            </div>
                        </div>

                        {/* Botón de Enviar */}
                        <button 
                            type="submit" 
                            className="btn w-100 mt-2 fw-bold text-white shadow-sm rounded-3 d-flex align-items-center justify-content-center"
                            style={{ 
                                background: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)', 
                                border: 'none',
                                padding: '10px 0'
                            }}
                        >
                            <span>Ingresar</span>
                            <i className="fas fa-sign-in-alt ms-2"></i>
                        </button>

                    </form>
                </div>
                
                {/* Pie de tarjeta */}
                <div className="card-footer text-center py-3 border-top border-secondary border-opacity-25" style={{ backgroundColor: 'rgba(30, 41, 59, 0.4)' }}>
                    <span className="small text-white-50" style={{ fontSize: '0.8rem' }}>© Plataforma Educativa</span>
                </div>

            </div>
        </div>
    )
}